<template>
  <span
    class="count-down"
    :style="{'color': value ? '#ccc' : color, 'cursor': value ? 'wait' : 'pointer', fontSize: fontSize}"
    @click="handleClick"
  >{{ value ? countingShowTxt : showTxt }}</span>
</template>
<script>
/**
 * @description 获取验证码倒计时（组件）
 */
export default {
  name: 'CountDown',
  props: {
    color: {
      type: String,
      default: 'inherint'
    },
    startNum: {
      type: Number,
      default: 60
    },
    initTxt: {
      type: String,
      default: '获取验证码'
    },
    countingTxt: {
      type: [String, Boolean],
      default: null
    },
    endTxt: {
      type: String,
      default: '重新获取'
    },
    value: {
      type: Boolean
    },
    fontSize: {
      type: String,
      default: 'inherit'
    }
  },
  computed: {
    countingShowTxt () {
      const time = this.timeCount > 9 ? this.timeCount : `0${this.timeCount}`
      if (this.countingTxt) {
        if (typeof this.countingTxt === 'string') {
          const hasTemp = this.countingTxt.indexOf('$time') > -1
          return hasTemp ? this.countingTxt.replace('$time', time) : `${this.countingTxt}(${time})`
        } else {
          return `${this.endTxt}(${time})`
        }
      } else {
        return time
      }
    }
  },
  data () {
    return {
      timer: null,
      timeCount: this.startNum,
      showTxt: this.initTxt
    }
  },
  watch: {
    value (val) {
      val && this.startCount()
    }
  },
  methods: {
    startCount () {
      /**
       * @description
       *  - 倒计时逻辑
       *  @return void
       */
      const _this = this
      this.timer = setInterval(() => {
        if (_this.timeCount > 0) {
          _this.timeCount = _this.timeCount - 1
        } else {
          clearInterval(_this.timer)
          _this.$emit('input', false)
          _this.timeCount = _this.startNum
          _this.showTxt = _this.endTxt
        }
      }, 1000)
    },
    handleClick () {
      /**
       * @description 组件的点击事件
       * @return void
       */
      if (!this.value) {
        this.$emit('click-event')
      }
    }
  }
}
</script>
